import React from 'react';
import { dashboardCustomizeConstants } from './constants';
import Widget1Properties from './Widget1Properties';
import Widget2Properties from './Widget2Properties';
import Widget3Properties from './Widget3Properties';
import Widget4Properties from './Widget4Properties';

const DashboardCustomProperties = (props) => {
  switch (props.properties.widgetTypeName) {
    case dashboardCustomizeConstants.widget1:
      return <Widget1Properties {...props} />;
    case dashboardCustomizeConstants.widget3:
      return <Widget3Properties {...props} />;
    case dashboardCustomizeConstants.widget4:
      return <Widget4Properties {...props} />;
    default:
      return <Widget2Properties {...props} />;
  }
};

export default DashboardCustomProperties;
